import React from "react";
import axios from "axios";

import setUpAxios from "../../helperFunctions/helperFunctions";

import Nav from "./nav";
import NavContext from "./context";

interface NavContainerProps {
  chargebeeSite: string;
  homeUrl: string;
  isDemo: boolean;
  isDemoing: boolean;
  isMobile: boolean;
  isSpoofing: boolean;
  isSuperAdmin: boolean;
  isTrialing: boolean;
  logoFilename: string;
  monarchBaseURL: string;
  navigationShrunk: boolean;
  permissions: string[];
  productTier: string;
  rewardsUrl: string;
  user: {
    id: string;
    profilePic: string;
    name: string;
  };
  userManagmentIntegrationURL?: string;
}

interface NavContainerState {
  pendingAwardsClaims: number;
  quickSpoofCompanies: any[];
  subscription: {
    showBottomFreeTrialWarning: boolean;
    showUpdatedSidebarTrialCTA: boolean;
    inTrial: boolean;
    daysLeft: number;
    paymentUrl: string;
  };
  unresolvedCount: number;
}

export default class NavContainer extends React.Component<
  NavContainerProps,
  NavContainerState
> {
  state = {
    pendingAwardsClaims: 0,
    quickSpoofCompanies: [],
    subscription: {
      showBottomFreeTrialWarning: false,
      showUpdatedSidebarTrialCTA: false,
      inTrial: false,
      daysLeft: 0,
      paymentUrl: null,
    },
    unresolvedCount: 0,
  };

  componentDidMount() {
    setUpAxios();
    $(".dummy-nav").remove();
    this.fetchQuickSpoofCompanies();
    this.fetchFreeTrialWarning();
    this.fetchUnresolvedCount();
    this.fetchPendingAwardsClaims();
  }

  render() {
    return (
      <NavContext.Provider
        value={{ monarchBaseURL: this.props.monarchBaseURL }}
      >
        <Nav
          location={window.location.pathname}
          {...this.props}
          {...this.state}
        />
      </NavContext.Provider>
    );
  }

  fetchUnresolvedCount = () => {
    axios
      .get("/api/frontend/navigation/badges/unresolved_bonus_reports")
      .then((response) => {
        this.setState({
          unresolvedCount: response.data,
        });
      });
  };

  fetchPendingAwardsClaims = () => {
    axios
      .get("/api/frontend/navigation/badges/pending_awards")
      .then((response) => {
        this.setState({
          pendingAwardsClaims: response.data,
        });
      });
  };

  fetchQuickSpoofCompanies = () => {
    axios
      .get("/api/frontend/navigation/quick_spoof_companies")
      .then((response) => {
        this.setState({
          quickSpoofCompanies: response.data,
        });
      });
  };

  fetchFreeTrialWarning = () => {
    axios
      .get("/api/frontend/navigation/free_trial_warning")
      .then((response) => {
        this.setState({
          subscription: {
            ...response.data,
          },
        });
      });
  };
}
